// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import MinicartDrawerState from "@store/Framework/Store/Store/Components/MinicartDrawer/MinicartDrawerState";
import { SndGrades } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: MinicartDrawerState = {
    isOpen: false,
};

const actions = {
    "Store/Components/MinicartDrawer/openMinicartDrawer": (draft: Draft<MinicartDrawerState>) => {
        draft.isOpen = true;
    },
    "Store/Components/MinicartDrawer/closeMinicartDrawer": (draft: Draft<MinicartDrawerState>) => {
        draft.isOpen = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type MinicartDrawerActions = Parameters<typeof reducer>[1];
export default reducer;
